import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="mobile-burger"
export default class extends Controller {
  connect() {
    const nav = document.querySelector('nav.primary-navigation');
    this.element.addEventListener('click', () => {
      nav.classList.toggle('open');
    })
  }
}
